module.exports = __webpack_public_path__ + "static/tandemex-matches-48293058a297e35fe1f2841d99994bd3.jpg";